/**
 * Schemas Zod de `/notificacoes` (`03-endpoints-draft.md §11`).
 *
 * `.strict()` como no resto do pacote: campo desconhecido é `422`, não silêncio.
 *
 * Não há schema de criação nem de atualização de conteúdo, e isso é intencional —
 * notificação não é recurso que o cliente cadastra. Ela nasce como efeito de um
 * fato de negócio (lead atribuído, agendamento próximo, integração falhou) dentro
 * da **mesma transação** que gravou o fato. As duas únicas escritas expostas são
 * marcar como lida, que não recebe corpo algum.
 */
import { z } from 'zod'

import { schemaLimite, schemaCursor } from '../comum/paginacao'

/**
 * `?naoLidas=true` é como a gaveta da topbar abre: o que interessa ao abrir é o que
 * ainda não foi visto. Sem o filtro vem tudo, que é o modo da tela "ver todas".
 *
 * Cursor e não offset (§6): a caixa cresce indefinidamente e o usuário rola —
 * `OFFSET` alto varreria as linhas antigas para descartá-las, e página numerada não
 * faz sentido em lista que recebe item novo no topo enquanto se navega.
 */
export const schemaFiltrosNotificacoes = z
  .object({
    limite: schemaLimite,
    cursor: schemaCursor,
    naoLidas: z.enum(['true']).optional(),
  })
  .strict()

export type FiltrosNotificacoes = z.infer<typeof schemaFiltrosNotificacoes>
